import * as Logger from '@thoughtspot/logger';
import _ from 'lodash';
Logger.registerOnErrorCallback(_.noop);
const createLogger = (name) => {
    return Logger.create(`chart-lib: ${name}`);
};
const LogLevel = Logger.LogLevel;
export { createLogger, LogLevel };
//# sourceMappingURL=logger.js.map